module.exports = __webpack_public_path__ + "img/32_bohle.7a40e820.jpeg";